import { Link } from 'react-router-dom';
import { getProductPath } from '@/utils/productLinks';

interface Product {
  id: number;
  title: string;
  image: string;
  category: string;
  compliance: string;
}

interface RelatedProductsProps {
  products: Product[];
}

export default function RelatedProducts({ products }: RelatedProductsProps) {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">You Might Also Like</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore our complete range of fire safety equipment and solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <Link
              key={product.id}
              to={getProductPath(product.id)}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow group"
            >
              <div className="aspect-w-16 aspect-h-12 bg-gray-100">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-48 object-cover object-center group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-medium text-red-600 bg-red-50 px-2 py-1 rounded-full">
                    {product.category}
                  </span>
                  <span className="text-xs text-gray-500">{product.compliance}</span>
                </div>

                <h3 className="text-lg font-semibold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                  {product.title}
                </h3>

                <div className="flex items-center justify-between">
                  <span className="text-red-600 font-medium group-hover:text-red-700 transition-colors">
                    View Details
                    <i className="ri-arrow-right-line ml-1"></i>
                  </span>

                  <span className="p-2 text-gray-400 group-hover:text-red-600 transition-colors">
                    <i className="ri-heart-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Products Button */}
        <div className="text-center mt-12">
          <Link
            to="/products"
            className="inline-flex items-center px-8 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap"
          >
            View All Products
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}